module.exports = __webpack_public_path__ + "static/media/store-pickup.57bda5ff.svg";